// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"c8d04c27","220":"c45a4471"}[chunkId] + ".chunk.css";
};